import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

interface UseAdTrackerProps {
  placement: string;
  adId?: string;
  enabled?: boolean;
}

export const useAdTracker = ({ placement, adId, enabled = true }: UseAdTrackerProps) => {
  const { user } = useAuth();

  const trackAdView = async (targetAdId: string) => {
    try {
      // Call rate-limited edge function instead of direct insert
      const { error } = await supabase.functions.invoke('submit-ad-view', {
        body: {
          ad_id: targetAdId,
          placement,
        },
      });

      if (error) {
        console.error('Error tracking ad view:', error);
      }
    } catch (error) {
      console.error('Error tracking ad view:', error);
    }
  };

  useEffect(() => {
    if (!enabled || !adId) return;

    // Track the view when component mounts or adId changes
    trackAdView(adId);
  }, [adId, enabled, placement, user?.id]);

  return { trackAdView };
};

export default useAdTracker;